export default __webpack_public_path__ + "static/media/matterhorn.0a076c8f.jpg";